const mappings = {
    'af-ZA': {
        'synonyms': {
            'af': null,
            'afr': null,
            'af-za': null,
            'af_za': null,
            'afrikaans': null
        },
        'label': 'Afrikaans'
    },
    'ar': {
        'synonyms': {
            'ar': null,
            'ara': null,
            'ar-ar': null,
            'ar_ar': null,
            'arabic': null
        },
        'label': 'Arabic'
    },
    'bg-BG': {
        'synonyms': {
            'bg': null,
            'bul': null,
            'bg-bg': null,
            'bg_bg': null,
            'bulgarian': null
        },
        'label': 'Bulgarian'
    },
    'ca-ES': {
        'synonyms': {
            'ca': null,
            'cat': null,
            'ca-fr': null,
            'ca_fr': null,
            'ca-es': null,
            'ca_es': null,
            'catalan': null
        },
        'label': 'Catalan'
    },
    'zh-CN': {
        'synonyms': {
            'zh-cn': null,
            'zh_cn': null
        },
        'label': 'Chinese (PRC)'
    },
    'zh-TW': {
        'synonyms': {
            'zh': null,
            'chi': null,
            'zh-tw': null,
            'zh_tw': null,
            'chinese': null
        },
        'label': 'Chinese (Taiwan)'
    },
    'cs-CZ': {
        'synonyms': {
            'cs': null,
            'cz': null,
            'cze': null,
            'cs-cz': null,
            'cs_cz': null,
            'czech': null
        },
        'label': 'Czech'
    },
    'da-DK': {
        'synonyms': {
            'da': null,
            'dan': null,
            'da-dk': null,
            'da_dk': null,
            'danish': null
        },
        'label': 'Danish'
    },
    'nl-BE': {
        'synonyms': {
            'nl-be': null,
            'nl_be': null,
            'dutch belgium': null
        },
        'label': 'Dutch (Belgium)'
    },
    'nl-NL': {
        'synonyms': {
            'nl': null,
            'dut': null,
            'nl-nl': null,
            'nl_nl': null,
            'dutch': null
        },
        'label': 'Dutch'
    },
    'en-AU': {
        'synonyms': {
            'aue': null,
            'aus': null,
            'en-au': null,
            'en_au': null,
            'english au': null
        },
        'label': 'English (Australia)'
    },
    'en-GB': {
        'synonyms': {
            'en': null,
            'eng': null,
            'en-gb': null,
            'en_gb': null,
            'english': null,
            'default': null
        },
        'label': 'English (Great Britain)'
    },
    'en-NZ': {
        'synonyms': {
            'en-nz': null,
            'en_nz': null,
            'english new zealand': null
        },
        'label': 'English (New Zealand)'
    },
    'en-US': {
        'synonyms': {
            'us': null,
            'ame': null,
            'en-us': null,
            'en_us': null,
            'english us': null
        },
        'label': 'English (US)'
    },
    'et-EE': {
        'synonyms': {
            'et-ee': null,
            'et_ee': null,
            'estonian': null
        },
        'label': 'Estonian'
    },
    'eu-ES': {
        'synonyms': {
            'eu-es': null,
            'eu_es': null,
            'basque': null
        },
        'label': 'Basque (Spain)'
    },
    'fi-FI': {
        'synonyms': {
            'fi': null,
            'fin': null,
            'fi-fi': null,
            'fi_fi': null,
            'finnish': null
        },
        'label': 'Finnish'
    },
    'fr-CA': {
        'synonyms': {
            'fr-ca': null,
            'fr_ca': null,
            'french canadian': null
        },
        'label': 'French (Canadian)'
    },
    'fr-FR': {
        'synonyms': {
            'fr': null,
            'fre': null,
            'fr-fr': null,
            'fr_fr': null,
            'french': null
        },
        'label': 'French'
    },
    'de-DE': {
        'synonyms': {
            'de': null,
            'ger': null,
            'de-de': null,
            'de_de': null,
            'german': null
        },
        'label': 'German'
    },
    'el-GR': {
        'synonyms': {
            'el': null,
            'gre': null,
            'el-gr': null,
            'el_gr': null,
            'greek': null
        },
        'label': 'Greek'
    },
    'gl-ES': {
        'synonyms': {
            'gl-es': null,
            'gl_es': null,
            'galician': null
        },
        'label': 'Galician (Spain)'
    },
    'he-IL': {
        'synonyms': {
            'he-il': null,
            'he_il': null,
            'hebrew': null
        },
        'label': 'Hebrew (Israel)'
    },
    'hr-HR': {
        'synonyms': {
            'hr': null,
            'hr-hr': null,
            'hr_hr': null,
            'croatian': null
        },
        'label': 'Croatian'
    },
    'hu-HU': {
        'synonyms': {
            'hu': null,
            'hun': null,
            'hu-hu': null,
            'hu_hu': null,
            'hungarian': null
        },
        'label': 'Hungarian'
    },
    'id-ID': {
        'synonyms': {
            'id': null,
            'ind': null,
            'id-id': null,
            'id_id': null,
            'indonesian': null
        },
        'label': 'Indonesian'
    },
    'it-IT': {
        'synonyms': {
            'it': null,
            'ita': null,
            'it-it': null,
            'it_it': null,
            'italian': null
        },
        'label': 'Italian'
    },
    'kk-KZ': {
        'synonyms': {
            'kk-kz': null,
            'kk_kz': null,
            'kazakh': null
        },
        'label': 'Kazakh (Kazakhstan)'
    },
    'lv-LV': {
        'synonyms': {
            'lt': null,
            'lv-lv': null,
            'lv_lv': null,
            'latvian': null
        },
        'label': 'Latvian'
    },
    'lt-LT': {
        'synonyms': {
            'lt': null,
            'lit': null,
            'lt-lt': null,
            'lt_lt': null,
            'lithuanian': null
        },
        'label': 'Lithuanian'
    },
    'ms-MY': {
        'synonyms': {
            'ms': null,
            'mal': null,
            'ms-my': null,
            'ms_my': null,
            'malay': null
        },
        'label': 'Malay'
    },
    'no-NO': {
        'synonyms': {
            'no': null,
            'nb': null,
            'nor': null,
            'nb-no': null,
            'nb_no': null,
            'no-no': null,
            'no_no': null,
            'norwegian': null
        },
        'label': 'Norwegian'
    },
    'pl-PL': {
        'synonyms': {
            'pl': null,
            'pol': null,
            'pl-pl': null,
            'pl_pl': null,
            'polish': null
        },
        'label': 'Polish'
    },
    'ro-RO': {
        'synonyms': {
            'ro-ro': null,
            'ro_ro': null,
            'romanian': null
        },
        'label': 'Romanian'
    },
    'ru-RU': {
        'synonyms': {
            'ru': null,
            'rus': null,
            'ru-ru': null,
            'ru_ru': null,
            'russian': null
        },
        'label': 'Russian'
    },
    'sr-RS': {
        'synonyms': {
            'sr-rs': null,
            'sr_rs': null,
            'serbian': null
        },
        'label': 'Serbian'
    },
    'sk-SK': {
        'synonyms': {
            'sk': null,
            'slo': null,
            'sk-sk': null,
            'sk_sk': null,
            'slovak': null
        },
        'label': 'Slovak'
    },
    'sl-SI': {
        'synonyms': {
            'sl': null,
            'slv': null,
            'sl-si': null,
            'sl_si': null,
            'slovenian': null
        },
        'label': 'Slovenian'
    },
    'es-ES': {
        'synonyms': {
            'es': null,
            'spa': null,
            'es-es': null,
            'es_es': null,
            'spanish': null
        },
        'label': 'Spanish'
    },
    'es-419': {
        'synonyms': {
            'es-419': null,
            'es_419': null,
            'latin america spanish': null
        },
        'label': 'Latin American Spanish'
    },
    'sv-SE': {
        'synonyms': {
            'sv': null,
            'swe': null,
            'sv-se': null,
            'sv_se': null,
            'swedish': null
        },
        'label': 'Swedish'
    },
    'th-TH': {
        'synonyms': {
            'th': null,
            'tha': null,
            'th-th': null,
            'th_th': null,
            'thai': null
        },
        'label': 'Thai'
    },
    'tr-TR': {
        'synonyms': {
            'tr': null,
            'tur': null,
            'tr-tr': null,
            'tr_tr': null,
            'turkish': null
        },
        'label': 'Turkish'
    },
    'uk-UA': {
        'synonyms': {
            'uk-ua': null,
            'uk_ua': null,
            'ukrainian': null
        },
        'label': 'Ukrainian'
    },
    'vi-VN': {
        'synonyms': {
            'vi-vn': null,
            'vi_vn': null,
            'vietnamese': null
        },
        'label': 'Vietnamese (Viet Nam)'
    },
    'NGT': {
        'synonyms': {
            'ngt': null
        },
        'label': 'Neutral Ground Truth'
    },
    'NGT-Latn': {
        'synonyms': {
            'ngt-latn': null
        },
        'label': 'Neutral Ground Truth - Latin exonyms'
    },
    'en-CA': {
        'synonyms': {
            'en-ca': null,
            'en_ca': null,
            'english canadian': null
        },
        'label': 'English (Canada)'
    },
    'ko-KR': {
        'synonyms': {
            'ko': null,
            'kor': null,
            'ko-kr': null,
            'ko_kr': null,
            'korean': null
        },
        'label': 'Korean'
    },
    'nb-NO': {
        'synonyms': {
            'nb': null,
            'nor': null,
            'nb-no': null,
            'nb_no': null,
            'norwegian': null
        },
        'label': 'Norwegian'
    },
    'pt-BR': {
        'synonyms': {
            'br': null,
            'pob': null,
            'pt-br': null,
            'pt_br': null,
            'portuguese br': null
        },
        'label': 'Portuguese (BR)'
    },
    'pt-PT': {
        'synonyms': {
            'pt': null,
            'por': null,
            'pt-pt': null,
            'pt_pt': null,
            'portuguese': null
        },
        'label': 'Portuguese'
    },
    'ru-Latn-RU': {
        'synonyms': {
            'ru-latn-ru': null,
            'ru_latn_ru': null
        },
        'label': 'Russian (Latin)'
    },
    'ru-Cyrl-RU': {
        'synonyms': {
            'ru-cyrl-ru': null,
            'ru_cyrl_ru': null
        },
        'label': 'Russian (Cyrlic)'
    },
    'es-MX': {
        'synonyms': {
            'mx': null,
            'spm': null,
            'es-mx': null,
            'es_mx': null,
            'spanish mx': null
        },
        'label': 'Spanish (Mexico)'
    },
    'defaultValue': {
        'value': 'en-GB',
        'label': 'English (Great Britain)'
    }
};

const traffic = {
    'ca': mappings['ca-ES'],
    'cs': mappings['cs-CZ'],
    'da': mappings['da-DK'],
    'de': mappings['de-DE'],
    'en': {
        'synonyms': {
            'en': null,
            'eng': null,
            'en-gb': null,
            'en_gb': null,
            'english': null,
            'us': null,
            'ame': null,
            'en-us': null,
            'en_us': null,
            'english us': null,
            'default': null
        },
        'label': 'English'
    },
    'es': {
        'synonyms': {
            'es': null,
            'spa': null,
            'es-es': null,
            'es_es': null,
            'spanish': null,
            'mx': null,
            'spm': null,
            'es-mx': null,
            'es_mx': null,
            'spanish mx': null
        },
        'label': 'Spanish'
    },
    'fi': mappings['fi-FI'],
    'fr': mappings['fr-FR'],
    'hu': mappings['hu-HU'],
    'it': mappings['it-IT'],
    'nl': mappings['nl-NL'],
    'no': mappings['no-NO'],
    'pl': mappings['pl-PL'],
    'pt': {
        'synonyms': {
            'br': null,
            'por': null,
            'pt-br': null,
            'pt_br': null,
            'portuguese': null,
            'pt': null,
            'pob': null,
            'pt-pt': null,
            'pt_pt': null,
            'portuguese br': null
        },
        'label': 'Portuguese'
    },
    'sk': mappings['sk-SK'],
    'sv': mappings['sv-SE'],
    'tr': mappings['tr-TR'],
    'defaultValue': {
        'value': 'en',
        'label': 'English (Great Britain)'
    }
};

const routingKeys = [
    'ar',
    'af-ZA',
    'bg-BG',
    'zh-TW',
    'cs-CZ',
    'da-DK',
    'nl-NL',
    'en-GB',
    'en-US',
    'fi-FI',
    'fr-FR',
    'de-DE',
    'el-GR',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ko-KR',
    'lt-LT',
    'ms-MY',
    'nb-NO',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ru-RU',
    'sk-SK',
    'sl-SI',
    'es-ES',
    'es-MX',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'defaultValue'
];

const searchKeys = [
    'NGT',
    'NGT-Latn',
    'af-ZA',
    'ar',
    'eu-ES',
    'bg-BG',
    'ca-ES',
    'zh-CN',
    'zh-TW',
    'cs-CZ',
    'da-DK',
    'nl-BE',
    'nl-NL',
    'en-AU',
    'en-NZ',
    'en-GB',
    'en-US',
    'et-EE',
    'fi-FI',
    'fr-CA',
    'fr-FR',
    'gl-ES',
    'de-DE',
    'el-GR',
    'hr-HR',
    'he-IL',
    'hu-HU',
    'id-ID',
    'it-IT',
    'kk-KZ',
    'lv-LV',
    'lt-LT',
    'ms-MY',
    'no-NO,',
    'nb-NO',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'ru-Latn-RU',
    'ru-Cyrl-RU',
    'sr-RS',
    'sk-SK',
    'sl-SI',
    'es-ES',
    'es-419',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'vi-VN',
    'defaultValue'
];

const mapsKeys = [
    'NGT',
    'NGT-Latn',
    'ar',
    'bg-BG',
    'zh-TW',
    'cs-CZ',
    'da-DK',
    'nl-NL',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-NZ',
    'en-US',
    'fi-FI',
    'fr-FR',
    'de-DE',
    'el-GR',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ko-KR',
    'lt-LT',
    'ms-MY',
    'nb-NO',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ru-RU',
    'ru-Latn-RU',
    'ru-Cyrl-RU',
    'sk-SK',
    'sl-SI',
    'es-ES',
    'es-MX',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'defaultValue'
];

const routing = {};
const search = {};
const maps = {};

routingKeys.forEach((key) => {
    routing[key] = mappings[key];
});

searchKeys.forEach((key) => {
    search[key] = mappings[key];
});

mapsKeys.forEach((key) => {
    maps[key] = mappings[key];
});

export default {
    traffic,
    routing,
    search,
    maps
};

export const defaultLanguage = 'en-GB';



// WEBPACK FOOTER //
// ./services/config/language/mappings.js